

export default function Error({ message, isPadding }) {
  return (
    <div className={`w-full flex justify-center items-center text-red-700 ${isPadding && "py-10"}`}>{message ? message : "There was an error occurred"}</div>
  )
};